import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getMedicineRemarksAdmin } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchMedicineRemarks = (page, pageSize, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getMedicineRemarksAdmin", page, pageSize, type],
        queryFn: () => getMedicineRemarksAdmin(page, pageSize, type),
        enabled: !!page || !!pageSize || !!type,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchMedicineRemarks;
